'use client';

import * as React from 'react';
import Well from '@/components/ui/Well';
import LayoutSplit from '@/components/ui/LayoutSplit';
import Animations from '@/components/ui/Animations';
import './styles.scss';

export interface IGuideProps {
  title: React.ReactNode;
  steps: {
    title: React.ReactNode;
    description?: React.ReactNode;
  }[];
}

const Guide: React.FunctionComponent<IGuideProps> = (props) => {
  return (
    <Well
      className={'guide'}
      theme="light"
    >
      <div className={'guide__title'}>
        <h2>{props.title}</h2>
        <Animations animation="animation09" />
      </div>
      <LayoutSplit className={'guide__steps'}>
        {props.steps.map((step, index) => (
          <div
            key={index}
            className={'guide__step'}
          >
            <div className={'guide__step__number'}>{index + 1}</div>
            <div className={'guide__step__title'}>{step.title}</div>
            {step.description && <div className={'guide__step__description'}>{step.description}</div>}
          </div>
        ))}
      </LayoutSplit>
    </Well>
  );
};

Guide.displayName = 'Guide';

export default Guide;
